import React from 'react';
import { Link } from 'react-router-dom';
import { fmtNum, fmtUSD } from '../../data/districts';
import { BrandMark } from '../ui';

// District-branded hero. Uses inline styles for colors (arbitrary hex from config).
const DistrictHero = ({ district, stats }) => {
  const { primary, secondary, accent } = district.colors;

  const initials = district.shortName
    ? district.shortName.slice(0, 4)
    : district.name.slice(0, 2).toUpperCase();

  const quickStats = [
    { label: 'Schools', value: fmtNum(stats.schoolCount) },
    { label: 'Tickets sold (YTD)', value: fmtNum(stats.ticketsYTD) },
    { label: 'Revenue (YTD)', value: fmtUSD(stats.revenueYTD) },
    { label: 'Avg. attendance', value: fmtNum(stats.avgAttendance) },
  ];

  return (
    <header
      className="relative overflow-hidden text-white"
      style={{ background: `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)` }}
    >
      {/* decorative glow */}
      <div
        className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full opacity-30 blur-3xl"
        style={{ backgroundColor: accent }}
      />

      {/* Top bar */}
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-5 flex items-center justify-between">
        <BrandMark layout="horizontal" className="h-7 sm:h-9 text-white" />
        <Link
          to="/demo"
          className="text-xs sm:text-sm font-medium bg-white/15 hover:bg-white/25 rounded-full px-3.5 py-1.5 transition-colors backdrop-blur"
        >
          ← All Districts
        </Link>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-10 pb-8 sm:pt-14 flex flex-col sm:flex-row items-center gap-6 animate-fade-in-up">
        <div
          className="flex-shrink-0 w-24 h-24 sm:w-28 sm:h-28 rounded-3xl flex items-center justify-center font-extrabold text-2xl sm:text-3xl shadow-lift ring-4 ring-white/20"
          style={{ backgroundColor: district.logo ? "#ffffff" : accent, color: primary }}
        >
          {district.logo ? (
            <img src={district.logo} alt={`${district.name} logo`} className="w-full h-full object-contain rounded-3xl p-2" />
          ) : (
            initials
          )}
        </div>

        <div className="text-center sm:text-left">
          <p className="uppercase tracking-widest text-xs sm:text-sm opacity-80 mb-1">
            Powered by Valley Tickets
          </p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold font-display leading-tight">
            {district.name}
          </h1>
          <p className="mt-2 text-base sm:text-lg opacity-90 max-w-2xl">
            {district.tagline}
          </p>
          <p className="mt-1 text-sm opacity-70">📍 {district.city}</p>
        </div>
      </div>

      {/* Quick stat strip */}
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 pb-8">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
          {quickStats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-white/10 backdrop-blur px-4 py-3 ring-1 ring-white/15"
            >
              <p className="text-xl sm:text-2xl font-bold font-display">{s.value}</p>
              <p className="text-xs opacity-80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </header>
  );
};

export default DistrictHero;
